import HandbookMessage from './HandbookMessage';

export default HandbookMessage;
